import Icon from './component/icon.vue';
import { Accordion, AccordionItem } from '@core/plugin/common/component/accordion';
import { Modal, ImageModal, CardModal } from '@core/plugin/common/component/modal';
import AutoSelectOnFocusDirective from "@core/plugin/common/directive/auto-select-on-focus";
import AutoFocusDirective from "@core/plugin/common/directive/auto-focus";
import TransitionHeight from './component/transition-height.vue';
import { StaticClass, StaticStyle } from "@core/plugin/common/directive/attribute-inheritance";
import { ModalOpen, ModalClose } from "@core/plugin/common/directive/modal-control";
var CoreCommon = /** @class */ (function () {
    function CoreCommon() {
    }
    CoreCommon.install = function (Vue, options) {
        Vue.component('icon', Icon);
        Vue.component('accordion', Accordion);
        Vue.component('accordion-item', AccordionItem);
        Vue.component('transition-height', TransitionHeight);
        Vue.component('modal', Modal);
        Vue.component('card-modal', CardModal);
        Vue.component('image-modal', ImageModal);
        Vue.directive('auto-focus', AutoFocusDirective);
        Vue.directive('auto-select-on-focus', AutoSelectOnFocusDirective);
        Vue.directive('no-inherit-class', StaticClass);
        Vue.directive('no-inherit-style', StaticStyle);
        Vue.directive('modal-open', ModalOpen);
        Vue.directive('modal-close', ModalClose);
    };
    return CoreCommon;
}());
export default CoreCommon;
